document.addEventListener('DOMContentLoaded', function () {
    let rowBtn = document.getElementById('rowsLayout');
    let rowBtnMobile = document.getElementById('rowsLayoutMobile');
    let gridBtn = document.getElementById('gridLayout');
    let gridBtnMobile = document.getElementById('gridLayoutMobile');

    function showRowLayout() {
        const gridCards = document.querySelectorAll('.grid-item__card');
        const gridRows = document.querySelectorAll('.grid-item__row');
        const gridPromo = document.querySelector('.grid-item__promotions');
        console.log('show row layout triggered');
        gridRows.forEach(row => row.classList.add('layout-visible'));
        gridCards.forEach(card => card.classList.remove('layout-visible'));

        rowBtn?.classList.add('ButtonActive');
        rowBtnMobile?.classList.add('ButtonActive');
        gridBtnMobile?.classList.remove('ButtonActive');
        gridBtn?.classList.remove('ButtonActive');

        if (gridPromo) gridPromo.style.display = 'none';
    }

    function showGridLayout() {
        const gridCards = document.querySelectorAll('.grid-item__card');
        const gridRows = document.querySelectorAll('.grid-item__row');
        const gridPromo = document.querySelector('.grid-item__promotions');
        console.log('show grid layout triggered');
        gridRows.forEach(row => row.classList.remove('layout-visible'));
        gridCards.forEach(card => card.classList.add('layout-visible'));

        rowBtn?.classList.remove('ButtonActive');
        rowBtnMobile?.classList.remove('ButtonActive');
        gridBtnMobile?.classList.add('ButtonActive');
        gridBtn?.classList.add('ButtonActive');

        if (gridPromo) gridPromo.style.display = '';
    }

    function attachClickOnce(button, callback) {
        if (!button || button.classList.contains('listener-attached')) return;
        button.addEventListener('click', callback);
        button.classList.add('listener-attached');
    }

    function setupLayoutToggle() {
        rowBtn = document.getElementById('rowsLayout');
        gridBtn = document.getElementById('gridLayout');
        rowBtnMobile = document.getElementById('rowsLayoutMobile');
        gridBtnMobile = document.getElementById('gridLayoutMobile');

        if (!rowBtn || !gridBtn) {
            console.error('Layout toggle buttons not found!');
            return;
        }

        attachClickOnce(rowBtn, showRowLayout);
        attachClickOnce(rowBtnMobile, showRowLayout);
        attachClickOnce(gridBtn, showGridLayout);
        attachClickOnce(gridBtnMobile, showGridLayout);

        // Default to grid layout
        showGridLayout();
    }

    setupLayoutToggle();

    const productGridContainer =
        document.querySelector('#ProductGridContainer') ||
        document.querySelector('[data-id="product-grid"]') ||
        document.querySelector('.collection .product-grid') ||
        document.querySelector('.product-grid');

    if (!productGridContainer) {
        console.error('Product grid container not found for observing.');
        return;
    }

    // Throttle DOM mutation responses
    let layoutSetupTimeout;
    const observer = new MutationObserver((mutationsList) => {
        const shouldResetLayout = mutationsList.some(mutation => {
            return Array.from(mutation.addedNodes).some(node =>
                node.nodeType === 1 && (
                    node.classList.contains('grid-item__card') ||
                    node.classList.contains('grid-item__row')
                )
            );
        });

        if (shouldResetLayout) {
            clearTimeout(layoutSetupTimeout);
            layoutSetupTimeout = setTimeout(() => {
                console.log('Product grid updated after filtering. Resetting to grid layout.');
                setupLayoutToggle();
            }, 200);
        }
    });

    observer.observe(productGridContainer, {
        childList: true,
        subtree: true
    });

    document.addEventListener('shopify:section:load', (event) => {
        console.log('shopify:section:load triggered', event.target);
        setupLayoutToggle();
    });
});
